// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1Ho2z","empty":"ModalGraph_empty__2XsMn"};